import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import YouthAndSportNumberCreatePage from './youth-and-sport-number-create'
import YouthAndSportNumberListPage from './youth-and-sport-number-list'
import YouthAndSportNumberUpdatePage from './youth-and-sport-number-update'

const youthAndSportNumberRoutes: Route[] = [
  {
    path: Paths.YOUTH_AND_SPORT_NUMBER_LIST_PAGE,
    element: <YouthAndSportNumberListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.YOUTH_AND_SPORT_NUMBER_CREATE_PAGE,
    element: <YouthAndSportNumberCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.YOUTH_AND_SPORT_NUMBER_UPDATE_PAGE,
    element: <YouthAndSportNumberUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default youthAndSportNumberRoutes
